import MyComponentTypes from '../MyComponent/Types'
const MyTableFilterControlHelpers = {
  addTypes(key: string, fnUI: any) {
    MyComponentTypes.addTypesGeneric(
      MyTableFilterControlHelpers.Types,
      key,
      fnUI
    )
  },
  addTypesFromListLazy(listWithKey: any) {
    MyComponentTypes.addTypesGenericFromListLazy(
      MyTableFilterControlHelpers.Types,
      listWithKey
    )
  },
  addTypesWrap(key: string, fnUI: any) {
    MyComponentTypes.addTypesGeneric(
      MyTableFilterControlHelpers.TypesWrap,
      key,
      fnUI
    )
  },
  Types: {
    _empty: MyComponentTypes.Types._empty
  },
  TypesWrap: {
    _empty: MyComponentTypes.TypesWrap._empty
  }
}

export default MyTableFilterControlHelpers
